import CartItem from './components/CartItem/CartItem'
import '../CartPage/CartPage.scss'

const CartPage = ({cartItemId,removeFromCart}) =>{


const productInCart = cartItemId.map(inCarts =>{
        return (
            <CartItem 
            title={inCarts.title} 
            url={inCarts.url} 
            color={inCarts.color} 
            oncklick={()=>{console.log('delete');}} 
            id={inCarts.id}
            price={inCarts.price}
            removeFromCart={removeFromCart}
            product={inCarts}
            />
        )

        
})
const noItem = <p className='cart-page__no-item'>There are no products in the cart...</p>

    return(
        <>
            <div className='cart-page'>
                <div className='cart-page__container' >
                       <p className='cart-page__title'>CART it is next step to buy your product</p> 
                        {productInCart}
                        {productInCart.length <=0 &&  noItem}
                </div>
                
            </div>
        </>
    )
}

export default CartPage;